/* eslint-disable @next/next/no-img-element */
//styles
import {
  LogosSection,
  Label,
  CarouselWrapper,
  LogosSlider,
  LogosList,
  Logo,
} from './Logos.styles';

export const logos_list = [
  {
    img: '/images/home/logos/carousel/general-motors.webp',
    alt: 'General Motors',
  },
  { img: '/images/home/logos/carousel/dhl.webp', alt: 'DHL' },
  {
    img: '/images/home/logos/carousel/backyard-products.webp',
    alt: 'Backyard Products',
  },
  { img: '/images/home/logos/carousel/home-depot.webp', alt: 'The Home Depot' },
  { img: '/images/home/logos/carousel/red-gold.webp', alt: 'Red Gold' },
  { img: '/images/home/logos/carousel/kraft-heinz.webp', alt: 'Kraft Heinz' },
  { img: '/images/home/logos/carousel/best-buy.webp', alt: 'Best Buy' },
  { img: '/images/home/logos/carousel/yamaha.webp', alt: 'Yamaha' },
  { img: '/images/home/logos/carousel/cabot.webp', alt: 'Cabot' },
  { img: '/images/home/logos/carousel/ab-inbev.webp', alt: 'AB InBev' },
  { img: '/images/home/logos/carousel/dell.webp', alt: 'Dell' },
  {
    img: '/images/home/logos/carousel/athletic-brewing.webp',
    alt: 'Athletic Brewing Co',
  },
  { img: '/images/home/logos/carousel/volvo.webp', alt: 'Volvo' },
  { img: '/images/home/logos/carousel/cascades.webp', alt: 'Cascades' },
  { img: '/images/home/logos/carousel/lawn-master.webp', alt: 'Lawn-Master' },
  {
    img: '/images/home/logos/carousel/cardinal-health.webp',
    alt: 'Cardinal Health',
  },
  {
    img: '/images/home/logos/carousel/scotts-miracle-gro.webp',
    alt: 'Scotts Miracle-Gro',
  },
  { img: '/images/home/logos/carousel/tjx.webp', alt: 'TJX' },
  {
    img: '/images/home/logos/carousel/olympic-steel.webp',
    alt: 'Olympic Steel',
  },
  {
    img: '/images/home/logos/carousel/steele-solutions.webp',
    alt: 'Steele Solutions Inc.',
  },
];

function LogoMark({ item }) {
  return (
    <Logo>
      <img src={item.img} alt={item.alt} />
    </Logo>
  );
}

export function Logos({ logos }) {
  const sliderspeed = logos.length * 4;

  return (
    <LogosSection>
      <Label>Trusted by the shippers who move the world</Label>
      <CarouselWrapper>
        <LogosSlider className="logoslider">
          <LogosList className="logoslider-list" items={sliderspeed}>
            {logos.map((item, key) => (
              <LogoMark key={key + '-a' + item.alt.trim()} item={item} />
            ))}
          </LogosList>
          <LogosList
            className="logoslider-list"
            items={sliderspeed}
            role="presentation"
          >
            {logos.map((item, key) => (
              <LogoMark key={key + '-b' + item.alt.trim()} item={item} />
            ))}
          </LogosList>
          <LogosList
            className="logoslider-list"
            items={sliderspeed}
            role="presentation"
          >
            {logos.map((item, key) => (
              <LogoMark key={key + '-c' + item.alt.trim()} item={item} />
            ))}
          </LogosList>
        </LogosSlider>
      </CarouselWrapper>
    </LogosSection>
  );
}
